import styled from 'styled-components';

export const PriceBreakUpMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-bottom: ${props.theme.spacing.large.l15};
  `
);

export const PriceBreakUpHeader = styled.div(
  props => `
    display: flex;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
    border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
  `
);

export const PriceBreakUpHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const PriceBreakUpInnerWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
      
  `
);

export const PriceBreakUpWrap = styled.div(
  props => `
    display: flex;
    width:100%;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};

    &:last-of-type{
      border-top: 1px solid #e5e5e5;
    }
  `
);

export const BreakUpInfoTextWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    width: 80%;
  `
);

export const PriceBreakUpMainText = styled.p(
  props => `
    font-size: ${props.fontSize ? props.fontSize : props.theme.font.large.font14};
    font-weight: ${props.fontWeight || ''};
    color: ${props.textColor || props.theme.colors.black.base};
  `
);

export const PriceBreakUpDiscountText = styled.p(
    props => `
      font-size: ${props.theme.font.large.font14};
      font-weight: ${props.fontWeight || ''};
      color: ${props.textColor || props.theme.colors.black.base};
    `
)

export const PriceBreakUpSubText = styled.p(
    props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.dark74};
      padding-top: ${props.theme.spacing.small.s2};
    `
);

export const BreakUpPriceWrap = styled.div(
    props => `
      width:20%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    `
);

export const BreakUpMainPriceText = styled.p(
    props => `
      font-size: ${props.fontSize ? props.fontSize : props.theme.font.large.font14};
      font-weight: ${props.fontWeight || ''};
      color: ${props.textColor || props.theme.colors.black.base};
    `
);

export const BreakUpDiscountPriceText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.green.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
)

export const BreakUpSubPriceText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.dark74};
        padding-top: ${props.theme.spacing.small.s2};
    `
);

export const CouponCodeWrap = styled.div(
    props => `
        display: flex;
        align-self: flex-start;
        border: 1px dashed ${props.theme.colors.grey.lighte7};
        border-radius: ${props.theme.misc.borderRadius.base};
        padding: ${props.theme.spacing.small.s1} ${props.theme.spacing.small.s5};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.dark74};
        font-weight: ${props.theme.font.fontWeight.bold};
        margin-top: ${props.theme.spacing.small.s2};
    `
);

export const PriceBreakUpTotalText = styled.p(
    props =>`
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const BreakUpTotalPriceText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

